import { useEffect } from "react";

/**
 * @description use like below
 * import React, { useRef } from 'react'
 * const Wrap = () => {
 *   const ref = useRef()
 *   useHoverOutside(ref, () => callback, isTrigger?:boolean)
 *   return <Element ref={ref} />
 * }
 */
export function useScaleOutside(isTrigger = false) {
  useEffect(() => {
    if (!isTrigger) return;
    const handleKeyDown = (e: any) => {
      if (e.ctrlKey && (e.code === "Equal" || e.code === "Minus")) {
        e.preventDefault();
      }
    };
    const handleWheel = (e: any) => {
      if (e.ctrlKey) {
        e.preventDefault();
      }
    };
    window.addEventListener("wheel", handleWheel, { passive: false });
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.addEventListener("wheel", handleWheel, { passive: false });
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isTrigger]);
}
